/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type UpdateAvailabilityStatusDto = {
    /**
     * New availability status
     */
    status: UpdateAvailabilityStatusDto.status;
    /**
     * Optional comment for manual block/unblock actions (max 500 characters)
     */
    comment?: string;
};
export namespace UpdateAvailabilityStatusDto {
    /**
     * New availability status
     */
    export enum status {
        AVAILABLE = 'AVAILABLE',
        SOLD = 'SOLD',
        RESERVED = 'RESERVED',
        PARTIAL_PAYMENT = 'PARTIAL_PAYMENT',
    }
}

